"use strict";

import { isLogged, getLoggedAdmin } from '../utils';

function setActiveLinks(currentPath) {
  const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
  navLinks.forEach(link => {
    const linkHref = link.getAttribute('href').split('/').pop().split('#')[0];

    if (linkHref === currentPath) {
      link.classList.add('active');

      const parentDropdown = link.closest('.dropdown');
      if (parentDropdown) {
        parentDropdown.classList.add('show');
      }
    }
  });

  const dropdowns = document.querySelectorAll('.navbar-nav .dropdown');

  dropdowns.forEach(dropdown => {
    const dropdownLinks = dropdown.querySelectorAll('.dropdown-menu .dropdown-item');

    dropdownLinks.forEach(dropdownLink => {
      const dropdownLinkHref = dropdownLink.getAttribute('href').split('/').pop();

      if (dropdownLinkHref === currentPath) {
        dropdown.classList.add('show');
        dropdownLink.classList.add('active');
      }
    });
  });
}

function initDropdown($dropdownMenu) {
  if ($dropdownMenu.length > 0) {
    const dropdownMenu = $dropdownMenu.find('.dropdown-menu');
    const dropdownItem = $dropdownMenu.find('.dropdown-item');

    dropdownItem.on('click', function (e) {
      window.location.href = $(this).attr('href');
      $('.close-menu-btn').trigger('click');
    });

    $(document).on('click', function (event) {
      if (!$(event.target).closest($dropdownMenu).length) {
        dropdownMenu.removeClass('show');
      }
    });
  }
}


function setupMenuBehavior() {
  const $navbar = document.querySelector("#navbarNav");
  const $toggleButton = document.querySelector(".navbar-toggler");
  const $closeButton = document.querySelector(".close-menu-btn");

  // Ouverture et fermeture du menu avec le bouton burger
  $toggleButton.addEventListener("click", function () {
    $navbar.classList.toggle("show");
  });

  // Fermeture du menu avec le bouton "X"
  $closeButton.addEventListener("click", function () {
    $navbar.classList.remove("show");
  });

  // Fermer le menu si l'utilisateur clique en dehors du menu
  document.addEventListener("click", function (event) {
    if (!$navbar.contains(event.target) && !$toggleButton.contains(event.target)) {
      $navbar.classList.remove("show");
    }
  });

  // Fonction pour rendre le menu sticky lors du scroll
  window.addEventListener("scroll", function () {
    const $headerSection = document.querySelector("#emamine-header-section");
    const $bannerContainer = document.querySelector("#banner-container");
    const $firstSection = $('section[class^="emamine"]:first-of-type');

    const scrollPosition = window.scrollY;
    if (scrollPosition > $bannerContainer.offsetHeight) {
      $headerSection.classList.add("sticky");
      $firstSection.css("marginTop", `${parseInt($headerSection.offsetHeight, 10)}px`);
    } else {
      $headerSection.classList.remove("sticky");
      $firstSection.css("marginTop", `0px`);

    }
  });

  initDropdown($('#dropdownMenuWhenWhere'));
}

// Modifier dynamiquement le menu selon l'état de l'admin
export function buildAdminMenu() {
  $('#dropdownMenuAdmin').remove();
  if (isLogged()) {
    const admin = getLoggedAdmin();
    const adminMenu = `
      <li class="nav-item dropdown" id="dropdownMenuAdmin">
        <a class="nav-link dropdown-toggle" href="#emamine-admin-login" id="dropdownLinkAdmin" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Bonjour ${admin.name || 'Admin'}
        </a>
        <ul class="dropdown-menu" aria-labelledby="dropdownLinkAdmin">
          <li><a class="dropdown-item" href="admin.html#emamine-admin-dashboard">Dashboard</a></li>
          <li><a class="dropdown-item" href="#emamine-admin-login" id="logoutLink">Se déconnecter</a></li>
        </ul>
      </li>
    `;

    $(".navbar-nav").append(adminMenu);

    $("#logoutLink").on('click', function (e) {
      e.preventDefault();
      localStorage.removeItem('admin');
      location.reload();
    });
  } else {
    const loginMenu = `
      <li class="nav-item dropdown" id="dropdownMenuAdmin">
        <a class="nav-link dropdown-toggle" href="admin.html" aria-label="Se connecter en tant qu'admin">
          Admin
        </a>
        <ul class="dropdown-menu" aria-labelledby="dropdownLinkAdmin">
          <li><a class="dropdown-item" href="admin.html#emamine-admin-login">Se connecter</a></li>
        </ul>
      </li>
    `;
    $(".navbar-nav").append(loginMenu);
  }
}

export function initMenu() {
  const currentPath = window.location.pathname.split('/').pop() || "index.html";
  $('#menu-container').load('../../components/menu.html', function () {
    setActiveLinks(currentPath);
    setupMenuBehavior();
    buildAdminMenu();
  });
}